export default {
  'number_with_delimiter': (x: string) => x.toLocaleString()
}
